import { useEffect, useMemo, useState } from 'react'

import { getAppInfo, leaveCentralDePrivacidade } from 'common'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { TLanguage } from 'contexts/app-context/types'
import { Routes, IS_DEV_ENV } from 'common/constants'
import { useLocation } from 'react-router-dom'

import { setFallbackUnknownErrorPageContent, ERROR_ICON } from '../utils'
import { TUseUnknownErrorPageReturn } from '../types'

const useUnknownErrorPage = (): TUseUnknownErrorPageReturn => {
  const { pathname } = useLocation()
  const [language, setLanguage] = useState<TLanguage>()

  const [isLoading, setIsLoading] = useState(false)

  const screen = useMemo(
    () => (pathname === Routes.UNKNOWN_ERROR ? Routes.UNKNOWN_ERROR : Routes.ERROR),
    [pathname],
  )

  useScreenFinishLoadTac({
    name: 'UnknownError',
    entity: undefined,
    action: 'UnknownError',
    screen,
    shouldSend: true,
    logLabel: 'send unknown error tac',
  })

  useEffect(() => {
    setIsLoading(true)

    const getAppInfoCallback = async () => {
      try {
        const appInfo = await getAppInfo()

        setLanguage(appInfo.language)
      } catch (error) {
        if (IS_DEV_ENV) {
          global.console.debug('getAppInfo failed, using fallback language:', error)
        }
      } finally {
        setIsLoading(false)
      }
    }

    getAppInfoCallback()
  }, [setLanguage])

  const onClickHandler = () => leaveCentralDePrivacidade()

  const content = setFallbackUnknownErrorPageContent(language)

  return {
    isLoading,
    button: {
      onClick: onClickHandler,
      text: content.confirmButton,
    },
    content: {
      ...content,
      icon: content.icon ?? ERROR_ICON,
    },
  }
}

export { useUnknownErrorPage }
